import {useEffect, useState} from "react"
import {isValid} from "date-fns"
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material"
import {styled} from "@mui/material/styles"
import {CalendarIcon} from "@indebted/assets"
import {useTranslation} from "react-i18next"
import {Calendar} from "@indebted/components/Calendar"

import {formatRelativeDate} from "../../../src/dateFormatter"
import {useLocale} from "../../../src/useLocale"

export function DateButton({
	startDate,
	maxDate,
	onDateChanged,
}: {
	startDate: Date
	maxDate: Date
	onDateChanged: (date: Date) => void
}) {
	const {t} = useTranslation()
	const {locale} = useLocale()
	const [datePickerOpen, setDatePickerOpen] = useState(false)
	const [currentDate, setCurrentDate] = useState<Date>(startDate)

	useEffect(() => {
		setCurrentDate(startDate)
	}, [startDate])

	const handleDateChange = (date: Date | null) => {
		if (date && isValid(date)) setCurrentDate(date)
	}

	const handleDatePickerOpen = () => {
		setCurrentDate(startDate)
		setDatePickerOpen(true)
	}

	return (
		<>
			<StartDateButton variant="outlined" onClick={handleDatePickerOpen} sx={{my: 2}}>
				{formatRelativeDate(startDate)}
				<CalendarIcon width={24} height={24} style={{verticalAlign: "middle", marginInlineEnd: "10px"}} />
			</StartDateButton>
			<Dialog open={datePickerOpen} onClose={() => setDatePickerOpen(false)}>
				<DialogTitle>{t("payment_arrangement_setup_page.select_start_date")}</DialogTitle>
				<DialogContent>
					<Calendar
						value={currentDate}
						onChange={handleDateChange}
						minDate={new Date()}
						maxDate={maxDate}
						locale={locale}
					/>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							setDatePickerOpen(false)
							onDateChanged(currentDate)
						}}
					>
						{t("payment_arrangement_setup_page.ok_button")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}

const StartDateButton = styled(Button)`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 0.8125rem;
	text-transform: none;
	border-radius: 0.5rem;
	border: 1px solid #e5e7eb;
	background: #f6f6f6;
	color: #000244;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.25rem;
	margin-top: 0 !important;
	margin-bottom: 0 !important;
	&:hover {
		background: #f6f6f6;
		border-color: #e5e7eb;
		box-shadow: none;
	}
`
